module.exports = __webpack_public_path__ + "static/media/fly0166.b4f92a5d.webp";